import { createFileRoute } from "@tanstack/react-router";
import { SiteShell, PageHero } from "@/components/site/SiteShell";
import { Section, SectionHeader, CTABand } from "@/components/site/Blocks";
import { buildHead } from "@/lib/seo-head";

export const Route = createFileRoute("/es/blog")({
  head: () =>
    buildHead({
      title: "Blog de Inversión Inmobiliaria en Español | Simply Approved",
      description:
        "Artículos educativos en español sobre préstamos DSCR, financiamiento de propiedades de inversión, flujo de caja y estrategia para inversionistas.",
      url: "/es/blog",
      locale: "es",
      keywords: "blog préstamos DSCR español, inversión inmobiliaria español, financiamiento propiedades alquiler",
      breadcrumbs: [
        { name: "Inicio", url: "/es" },
        { name: "Blog", url: "/es/blog" },
      ],
      service: { name: "Blog educativo para inversionistas" },
    }),
  component: BlogPage,
});

function BlogPage() {
  return (
    <SiteShell>
      <PageHero eyebrow="Blog" title="Educación en español para inversionistas inmobiliarios." subtitle="Guías sobre préstamos DSCR, financiamiento de alquileres y flujo de caja." />
      <Section>
        <SectionHeader title="Próximamente" center />
        <p className="mx-auto max-w-2xl text-center text-muted-foreground">
          Estamos preparando artículos en español sobre préstamos DSCR, estrategia de alquileres a
          corto plazo, financiamiento para extranjeros y más. Mientras tanto, explore nuestro blog en
          inglés.
        </p>
      </Section>
      <CTABand title="¿Necesita ayuda con su escenario?" body="Hable con un oficial de préstamos mientras preparamos más contenido en español." />
    </SiteShell>
  );
}
